import { createSlice } from "@reduxjs/toolkit";
const langSlice = createSlice({
    name: "langSlice",
    initialState: {
        selectedLang: "en-IN",
        selectedVoice: "en-IN-NeerjaNeural"
    },
    reducers: {
        changeLang: (state, action) => {
            state.selectedLang = action.payload;
        },
        selectedVoice: (state, action) => {
            state.selectedVoice = action.payload;
        },
    }
});
// 
export const { changeLang ,selectedVoice} = langSlice.actions;
export default langSlice.reducer;